import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IColorCombination, IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BuyMeGiftOrdersService {
  constructor(private readonly http: HttpClient) {}
  getAllBuyMeGiftOrders(params: IPaginationParams): Observable<ApiResponse> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/buy-me-gifts', { params: httpParams });
  }

  exportBuyMeGiftOrders(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '')
      .set('userId', filterData.userId ? filterData.userId : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/buy-me-gifts/export`, filterData, options);
  }

  syncBuyMeGiftOrders(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/admin/buy-me-gifts/sync-buy-me-orders');
  }

  syncBuyMeGifts(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/admin/buy-me-gifts/sync-buy-me');
  }
}
